<template>
    <div>
        <page-header
            :title="$t('pages.admin.users.title')"
            icon-class="mdi mdi-account-group"
        >
            <div class="text-right"></div>
        </page-header>
        <div class="row">
            <div class="col-12 grid-margin stretch-card">
                <user-filter :filter.sync="filter" />
            </div>
        </div>
        <div class="card shadow-sm">
            <div class="card-body">
                <static-loading-indicator-icon
                    :loading="$store.getters.shouldLoadLocal"
                />
                <div class="table-responsive">
                    <table class="table table-striped table-borderless">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Subscribed</th>
                                <th>Health</th>
                                <th>Referral Partner</th>
                                <th>{{ $t("actions.actions") }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="user in paginationData.data">
                                <td :class="{ blocked: user.blocked }">
                                    <i
                                        v-if="user.is_admin"
                                        class=" mdi mdi-18px mdi-shield-account float-left pr-1"
                                    ></i>
                                    {{ user.first_name }}
                                    {{ user.last_name }}
                                </td>
                                <td>
                                    <span
                                        class="badge badge-success"
                                        v-if="user.is_subscribed"
                                    >
                                        <i class="mdi mdi-check"></i>
                                    </span>
                                    <span class="badge badge-danger" v-else>
                                        <i class="mdi mdi-close"></i>
                                    </span>
                                </td>
                                <td>
                                    <i
                                        class="mdi mdi-heart"
                                        :class="[
                                            {
                                                'text-danger':
                                                    user.question_answers &&
                                                    hasHealthProblem(
                                                        user.question_answers
                                                    ),
                                                'text-secondary':
                                                    user.question_answers ===
                                                    null
                                            },
                                            'text-primary'
                                        ]"
                                    ></i>
                                </td>
                                <td>
                                    {{ user.referrer_partner === null ? '' : user.referrer_partner.partner }}
                                </td>
                                <td>
                                    <router-link
                                        tag="button"
                                        class="btn btn-outline-primary btn-sm"
                                        :to="{
                                            name: 'admin.user.info',
                                            params: { user: user.id }
                                        }"
                                    >
                                        <i class="mdi mdi-eye"></i>
                                    </router-link>
                                    <button
                                        v-if="!user.blocked && !user.is_admin"
                                        class="btn btn-outline-danger btn-sm float-right "
                                        @click="selectedUser = user"
                                    >
                                        <i class="mdi mdi-lock"></i>
                                    </button>
                                    <button
                                        v-if="user.blocked"
                                        class="btn btn-outline-info btn-sm float-right "
                                        @click="unblockUser(user.id)"
                                    >
                                        <i class="mdi mdi-lock-open"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="mt-3">
                        <pagination
                            :data="paginationData"
                            @pagination-change-page="getUsers"
                        ></pagination>
                    </div>
                </div>
                <user-block-modal
                    :selected="selectedUser"
                    @user-blocked="onUserBlocked"
                    @modal-close="selectedUser = null"
                ></user-block-modal>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "../../Includes/PageHeader";
import AdminUsersRepository from "../../../repositories/Admin/AdminUsersRepository";
import UserBlockModal from "./UserBlockModal";
import StaticLoadingIndicatorIcon from "../../Includes/StaticLoadingIndicatorIcon";
import UserFilter from "./Includes/UserFilter";

export default {
    name: "UserManagament",
    components: {
        PageHeader,
        UserBlockModal,
        StaticLoadingIndicatorIcon,
        UserFilter
    },
    data: () => ({
        paginationData: {},
        selectedUser: null,
        filter: {}
    }),
    watch: {
        filter: {
            handler(val) {
                if (val.name && val.name.length > 3) {
                    this.getUsers();
                }
                if (!val.name) {
                    this.getUsers();
                }
            },
            deep: true
        }
    },
    methods: {
        getUsers(page = 1) {
            AdminUsersRepository.getAllUsers(page, this.filter).then(res => {
                this.paginationData = res.data;
            });
        },
        onUserBlocked() {
            this.$snotify.success(this.$t("actions.blocked"));
            this.selectedUser = null;
            this.getUsers();
        },
        unblockUser(user) {
            AdminUsersRepository.unblockUser(user).then(res => {
                this.$snotify.success(this.$t("actions.unblocked"));
                this.getUsers();
            });
        },
        hasHealthProblem(answers) {
            for (const answer of answers) {
                if (answer) return true;
            }
        }
    }
};
</script>
